/**
 * Get global stored currency.
 * @returns currency string eg. EUR, SEK, USD
 */
export const getCurrency = () => window["CURRENT_CURRENCY"] || "n/a"
